import { FunctionComponent } from "react"

import OutlineBtn from "@fuse/sharedComponents/buttons/OutlineBtn"
import SolidBtn from "@fuse/sharedComponents/buttons/SolidBtn"

import {
  DownloadLinkMap,
  onOpenDownloadLink,
  useDeviceDetection,
} from "@fuse/utils/DeviceDection"

interface AppDownloadButtonProps {
  label: string
  className?: string
  onClick?: () => void
  isButtonTypeSolid?: boolean
}

const AppDownloadButton: FunctionComponent<AppDownloadButtonProps> = ({
  label,
  className,
  onClick,
  isButtonTypeSolid = true,
}) => {
  const device = useDeviceDetection()
  const downloadLink = DownloadLinkMap[device]

  if (isButtonTypeSolid) {
    return (
      <SolidBtn
        className={"px-[20px] py-[7px]" + className}
        onClick={() => (onClick ? onClick() : onOpenDownloadLink(downloadLink))}
      >
        {label}
      </SolidBtn>
    )
  } else {
    return (
      <OutlineBtn
        label={label}
        className={"px-[20px] py-[7px]" + className}
        onClick={() => (onClick ? onClick : onOpenDownloadLink(downloadLink))}
      />
    )
  }
}

export default AppDownloadButton
